import React, { useEffect, useState, useRef, Component } from 'react';
// Hook for scroll animations using Intersection Observer
export function useScrollAnimation() {
  useEffect(() => {
    // Check if this is a direct navigation from prompt page
    const isDirectNavigation = sessionStorage.getItem('directNavigation') === 'true';
    // Select all elements with reveal classes
    const allRevealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        } else {
          // Optional: remove the class when out of view for re-animation
          // entry.target.classList.remove('active');
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -100px 0px' // Negative bottom margin to trigger earlier
    });
    // Initialize observer after a short delay to ensure proper setup
    setTimeout(() => {
      allRevealElements.forEach(el => {
        // If it's a direct navigation, don't reset animation states
        if (!isDirectNavigation) {
          // Reset animation state first
          el.classList.remove('active');
        }
        // Then observe
        observer.observe(el);
      });
      // Clear the direct navigation flag
      sessionStorage.removeItem('directNavigation');
    }, 200);
    return () => {
      allRevealElements.forEach(el => {
        observer.unobserve(el);
      });
    };
  }, []);
  return null;
}
// Component to wrap around the app to enable animations
export const AnimationProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    // Check if this is a direct navigation from prompt page
    const isDirectNavigation = sessionStorage.getItem('directNavigation') === 'true';
    // Set loaded after a small delay to ensure DOM is ready
    setTimeout(() => {
      setIsLoaded(true);
    }, 100);
    // Initialize scroll animations
    const allRevealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -100px 0px'
    });
    // If it's a direct navigation, don't reset animation states
    if (!isDirectNavigation) {
      allRevealElements.forEach(el => {
        observer.observe(el);
      });
    }
    return () => {
      allRevealElements.forEach(el => {
        observer.unobserve(el);
      });
    };
  }, []);
  return <div className={`animation-wrapper ${isLoaded ? 'loaded' : ''}`} data-id="element-1878">
      {children}
    </div>;
};